// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartitionStatus } from './PartitionStatus';
import {
  PartitionStatusFromJSON,
  PartitionStatusFromJSONTyped,
  PartitionStatusToJSON,
  PartitionStatusToJSONTyped,
} from './PartitionStatus';
import type { Metadata } from './Metadata';
import {
  MetadataFromJSON,
  MetadataFromJSONTyped,
  MetadataToJSON,
  MetadataToJSONTyped,
} from './Metadata';
import type { PartitionSpec } from './PartitionSpec';
import {
  PartitionSpecFromJSON,
  PartitionSpecFromJSONTyped,
  PartitionSpecToJSON,
  PartitionSpecToJSONTyped,
} from './PartitionSpec';

/**
 *
 * @export
 * @interface PartitionEntity
 */
export interface PartitionEntity {
  /**
   *
   * @type {string}
   * @memberof PartitionEntity
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionEntity
   */
  environment?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionEntity
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionEntity
   */
  managementSource?: string;
  /**
   *
   * @type {Metadata}
   * @memberof PartitionEntity
   */
  metadata?: Metadata;
  /**
   *
   * @type {PartitionSpec}
   * @memberof PartitionEntity
   */
  spec?: PartitionSpec;
  /**
   *
   * @type {PartitionStatus}
   * @memberof PartitionEntity
   */
  status?: PartitionStatus;
  /**
   *
   * @type {string}
   * @memberof PartitionEntity
   */
  updatedAt?: string;
}

/**
 * Check if a given object implements the PartitionEntity interface.
 */
export function instanceOfPartitionEntity(
  value: object,
): value is PartitionEntity {
  return true;
}

export function PartitionEntityFromJSON(json: any): PartitionEntity {
  return PartitionEntityFromJSONTyped(json, false);
}

export function PartitionEntityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PartitionEntity {
  if (json == null) {
    return json;
  }
  return {
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    environment: json['environment'] == null ? undefined : json['environment'],
    id: json['id'] == null ? undefined : json['id'],
    managementSource:
      json['management_source'] == null ? undefined : json['management_source'],
    metadata:
      json['metadata'] == null ? undefined : MetadataFromJSON(json['metadata']),
    spec:
      json['spec'] == null ? undefined : PartitionSpecFromJSON(json['spec']),
    status:
      json['status'] == null
        ? undefined
        : PartitionStatusFromJSON(json['status']),
    updatedAt: json['updated_at'] == null ? undefined : json['updated_at'],
  };
}

export function PartitionEntityToJSON(json: any): PartitionEntity {
  return PartitionEntityToJSONTyped(json, false);
}

export function PartitionEntityToJSONTyped(
  value?: PartitionEntity | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    created_at: value['createdAt'],
    environment: value['environment'],
    id: value['id'],
    management_source: value['managementSource'],
    metadata: MetadataToJSON(value['metadata']),
    spec: PartitionSpecToJSON(value['spec']),
    status: PartitionStatusToJSON(value['status']),
    updated_at: value['updatedAt'],
  };
}
